import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { getIsLoggedIn, getIsLoginUser, getIsFetchingUser } from 'Store/User/selectors';
import { fetchIsLoginUser, createPasswordToCustomer, fetchCurrentUser } from 'Store/User/thunks';
import ConfirmationLogin from 'Pages/OrderConfirmationPage/ConfirmationLogin/ConfirmationLogin';
import { getCustomerEmail } from 'Store/Order/selectors';

interface IPropsInternal {
  isFetching: boolean;
  isLoggedIn: boolean;
  isPasswordUser: boolean;
  customerEmail: string;
  fetchCurrentUser: () => void;
  fetchIsLoginUser: (email: string) => void;
  createPasswordToCustomer: (password: string) => void;  
}

interface IState {
  passwordInput: string;
}

type Props = IPropsInternal;

class ConfirmationLoginContainer extends React.PureComponent<Props, IState> {
  constructor(props: Props) {
    super(props);

    this.state = {
      passwordInput: '',
    }
  }

  componentWillMount() {
    const { customerEmail } = this.props;
    this.props.fetchIsLoginUser(customerEmail);
  }

  componentWillReceiveProps(nextProps: Props) {
    if (this.props.isPasswordUser !== nextProps.isPasswordUser && nextProps.isPasswordUser) {
      this.props.fetchCurrentUser();
    }
  }
  onPasswordChange = (e: React.FormEvent<HTMLInputElement>) => {
    this.setState({ passwordInput: e.currentTarget.value });
  }

  onPasswordSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const { passwordInput } = this.state;
    this.props.createPasswordToCustomer(passwordInput);
  }

  render() {
    if (this.props.isFetching) {
      return null;
    }

    return (
      <ConfirmationLogin 
        isLoggedIn={ this.props.isLoggedIn }
        isPasswordUser={ this.props.isPasswordUser }
        currentInput={ this.state.passwordInput }
        onPasswordChange={ this.onPasswordChange }
        onPasswordSubmit={ this.onPasswordSubmit }
      />
    );
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    isFetching: getIsFetchingUser(state),
    isLoggedIn: getIsLoggedIn(state),
    isPasswordUser: getIsLoginUser(state),
    customerEmail: getCustomerEmail(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchIsLoginUser,
    fetchCurrentUser,
    createPasswordToCustomer,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(ConfirmationLoginContainer);


// WEBPACK FOOTER //
// ./src/pages/OrderConfirmationPage/ConfirmationLogin/ConfirmationLoginContainer.tsx